<template>
    <div class="courses-single-page bg-dark-blue" style="overflow-y: auto;">
        <div v-on:click="$router.push('/admin/users/0')" class="new-btn">
            New User
        </div>
        <div v-on:click="$router.push('/')" class="back-btn">
            Back
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="card mt-3">
                                <div class="container-fluid p-5 pt-0">
                                    <div class="content pt-0">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <div class="title text-dark-blue mr-4">
                                                    Users
                                                </div>
                                                <div class="site-select mb-2" v-if="sites">
                                                    <select v-model="selectedSite" class="form-control">
                                                        <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="actions-top d-flex align-items-end">
                                                <!--

                                                <div v-show="userRole == 'admin'" v-on:click="$router.push('/admin/users/bulkEnrollment')" class="tab-button" style="border: 1px solid white;">
                                                    Bulk Enrollment
                                                </div>
                                                    -->
                                                <button class="tab-button" style="margin-left: 10px; border: 1px solid white;" v-on:click="exportCsv()">
                                                    CSV Export
                                                </button>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex align-items-center" v-if="selectedSite && selectedSite.divisions && selectedSite.divisions.length">
                                                <br />
                                                <div class="subtitle text-dark-blue mr-4">
                                                    Divisions
                                                </div>
                                                <div class="site-select mb-2">
                                                    <select v-model="selectedDivision" class="form-control">
                                                        <option value="">All Divisions</option>
                                                        <option v-for="division in selectedSite.divisions" :value="division">{{division}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-responsive">

                                            <table class="table table-bordered bg-white text-center" style="overflow-y:scroll; display:table; max-height: 600px;">
                                                <thead>
                                                    <tr style="font-weight: 600;">
                                                        <td>Name</td>
                                                        <td>Surname</td>
                                                        <td>Email</td>
                                                        <td>Role</td>
                                                        <td>Division</td>
                                                        <td>Courses</td>
                                                        <td></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="user in filteredUsers">
                                                        <td>
                                                            <div class="centered">
                                                                {{ user.firstName }}
                                                            </div>
                                                        </td>
                                                        <td>{{ user.lastName }}</td>
                                                        <td>{{ user.email }}</td>
                                                        <td>{{ user.roles }}</td>
                                                        <td>{{ user.division }}</td>
                                                        <td>
                                                            <div v-for="userCourse in user.userCourses">
                                                                ({{ userCourse.course.name }})
                                                            </div>
                                                            <div v-show="user.userCourses.length < 1">
                                                                No courses
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <router-link :to="{ name: 'AdminUsersDetails', params: { id: user.id }}">
                                                                <div class="btn-add-alt-2 p-2 d-flex justify-content-center align-items-center text-center">
                                                                    <span>EDIT</span>
                                                                    <i class="fa fa-pencil ml-2"></i>
                                                                </div>
                                                            </router-link>
                                                        </td>
                                                    </tr>
                                                    <tr v-show="filteredUsers.length < 1">
                                                        <td colspan="6">No users for selected site</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!--<router-link class="btn-cms-green" style="margin-left: 10px;" to="/admin/users/0">New User</router-link>
                                        <router-link class="btn-cms-blue" style="margin-left: 10px;" to="/admin/users/bulkEnrollment">Bulk Enrollment</router-link>
                                        <button class="btn-cms-grey" style="margin-left: 10px;" v-on:click="exportCsv()">CSV Export</button>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- courses-single -->
</template>

<style scoped>

    .back-btn {
        position: fixed;
        right: 1em;
        bottom: 1em;
        background-color: #42C1C4;
        color: white;
        padding: 10px 20px;
        border-radius: 12px;
        z-index: 1000;
        margin-right: 30px;
    }

        .back-btn:hover {
            background-color: white;
            color: #42C1C4;
            cursor: pointer;
            border: 1px solid #42C1C4;
        }

    .new-btn {
        position: fixed;
        right: 7em;
        bottom: 1em;
        background-color: #42C1C4;
        color: white;
        padding: 10px 20px;
        border-radius: 12px;
        z-index: 1000;
        margin-right: 30px;
    }

        .new-btn:hover {
            background-color: white;
            color: #42C1C4;
            cursor: pointer;
            border: 1px solid #42C1C4;
        }

    td {
        vertical-align: middle;
    }

    .tab-button {
        border-radius: 8px 8px 0 0;
        border: 1px solid #B8BEBF;
        background-color: #42C1C4;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        width: 200px;
        padding: 10px;
    }

        .tab-button:hover {
            background-color: white;
            color: #282D69;
            cursor: pointer;
            border: 1px solid #282D69 !important;
        }
</style>

<script>
    export default {
        name: 'AdminUsers',
        data: function () {
            return {
                users: [],
                sites: [],
                selectedSite: null,
                selectedDivision: ""
            }
        },
        watch: {
            selectedSite: function (newVal, oldVal) {
                this.selectedDivision = "";
            }
        },
        props: {

        },
        computed: {
            userRole() {
                if (this.$store.state) {
                    var roles = this.$store.state.user.roles;
                    return roles[0];
                }
            },
            userSiteId() {
                var id = this.$store.state.user.siteId;
                return id;
            },
            filteredUsers() {
                var filtered = [];

                debugger;
                // if (this.userRole == "author") {
                //   filtered = this.users;
                // }
                //else {
                if (this.selectedSite) {
                    for (var i = 0; i < this.users.length; i++) {
                        var currentUser = this.users[i];
                        if (currentUser.siteId == this.selectedSite.id) {
                            filtered.push(currentUser);
                        }
                    }
                }
                //}

                if (this.selectedDivision) {
                    debugger;
                    filtered = filtered.filter(x => x.division == this.selectedDivision);
                }

                return filtered;
            }
        },
        methods: {
            getSiteName: function (siteId) {

                for (var i = 0; i < this.sites.length; i++) {
                    var site = this.sites[i];
                    if (site.id == siteId)
                        return site.name;
                }

                return "Unknown";
            },
            exportCsv: async function () {

                // fetch a fresh list that also includes soft-deleted users
                // (the on-screen table still shows active users only)
                var allUsers = await this.web(`/users?includeDeleted=true`, "Loading users") || [];

                // apply the same site/division filters the table uses
                let users = allUsers;
                if (this.selectedSite) {
                    users = users.filter(x => x.siteId == this.selectedSite.id);
                }
                if (this.selectedDivision) {
                    users = users.filter(x => x.division == this.selectedDivision);
                }

                var csvContent = "email,name,surname,id_number,division,course,enrolled_date,completed,completed_date,score,passed,is_deleted\r\n";
                console.log(users);
                for (var u = 0; u < users.length; u++) {
                    var user = users[u];
                    var isDeleted = user.isDeleted ? "true" : "false";

                    if (user.userCourses && user.userCourses.length) {
                        for (var i = 0; i < user.userCourses.length; i++) {
                            var userCourse = user.userCourses[i];
                            csvContent += `${user.email},${user.firstName},${user.lastName},'${user.idNumber || ""},${user.division || ""},${userCourse.course.name},${userCourse.createdDateTime},${userCourse.completed},${userCourse.completedDateTime},${userCourse.score},${userCourse.passed},${isDeleted}\r\n`;
                        }
                    }
                    else {
                        csvContent += `${user.email},${user.firstName},${user.lastName},'${user.idNumber || ""},${user.division || ""},,,,,,,${isDeleted}\r\n`;
                    }
                }

                var pom = document.createElement('a');
                var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                var url = URL.createObjectURL(blob);
                pom.href = url;
                pom.setAttribute('download', `export.csv`);
                pom.click();
            }
        },
        async mounted() {


            this.users = await this.web(`/users`, "Loading users");
            this.sites = await this.web("/sites", "Loading sites");
            this.selectedSite = this.sites[0];

            debugger;
            var crumbs = {};
            crumbs["/admin/users"] = "Users";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>
